const styles = theme => ({
    cardBody1: {
        flex: '1 0 auto',
    },
    cardAvatar: {
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        maxHeight: 200,
        padding: '10px',
        [theme.breakpoints.down('md')]: {
            maxHeight: 170,
        }
    },
    cancelled: {
        border: 'solid 4px red',
        '&::after': {
            Body1: "'Cancelled'",
            color: 'red',
            fontSize: '5rem',
            textAlign: 'center',
            position: 'absolute',
            fontFamily: 'Open Sans',
            display: 'inline-block',
            width: 'calc(100% - 50px)',
            background: 'rgba(0,0,0, 0.2)',
            [theme.breakpoints.down('md')]: {
                fontSize: '2rem',
            }
        }
    },
    alertPanel: {
        width: '100%',
        alignItems: 'center',
        marginBottom: theme.spacing(1),
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    icon: {
        fontSize: 20
    },
    newToIndustry: {
        fontSize: 14,
        color: theme.palette.text.primary
    },
    dropdown: {
        paddingRight: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    fatiguePanel: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(5)
    },
    margin: {
        [theme.breakpoints.down('md')]: {
            margin: 0
        },
    }
});

export default styles;